import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { TextAreaCardDisplay } from './textAreaCardDisplay';
const CONTAINER_CSS = css `
  filter: drop-shadow(4px 4px 0 black);
`;
export const TextAreaCardsDisplay = ({ cards, size, isFourColorDeck, overrideColor, overrideBackgroundColor }) => {
    return (_jsx("span", { css: CONTAINER_CSS, children: cards.map((card, i) => (_jsx(TextAreaCardDisplay, { card: card, size: size, isFourColorDeck: isFourColorDeck, overrideColor: overrideColor, overrideBackgroundColor: overrideBackgroundColor }, i))) }));
};
